import { createSlice } from '@reduxjs/toolkit';

// Identity-check state for the create-lead wizard (design 2026-10-04).
//   status:       'idle' | 'checking' | 'done' | 'error'
//   check:        last authoritative check result (see utils/leadIdentityApi.normaliseCheck)
//   resolution:   the operator's `identity_resolution`, sent with the create POST
//   note:         one-line confirmation shown on later steps ("New patient — no existing records")
//   followUpRequest: archived/active lead the operator chose to follow up instead of creating
const initialIdentity = {
    status: 'idle',
    crmDone: false,
    check: null,
    resolution: null,
    note: '',
    followUpRequest: null,
};

const slice = createSlice({
    name: 'createLeadDialog',
    initialState: { open: false, identity: initialIdentity, call: null, baselineLeadId: null },
    reducers: {
        // Optional payload `{ call }` from the call flow (CU-869fmc59c): the call this lead is being
        // created for, so the wizard can report the saved lead back (CALL_FLOW_LEAD_CREATED_EVENT).
        // The form's own starting values are put in newLeadDetail.personalDetail by the caller.
        openCreateLeadDialog(state, action) {
            state.open = true;
            state.identity = initialIdentity;
            state.call = action?.payload?.call ?? null;
            // The `createLead` id already in the lead slice when the wizard opened (never a lead it made).
            state.baselineLeadId = action?.payload?.baselineLeadId ?? null;
        },
        closeCreateLeadDialog(state) {
            state.open = false;
            state.identity = initialIdentity;
            state.call = null;
            state.baselineLeadId = null;
        },
        setIdentityStatus(state, action) {
            state.identity.status = action.payload;
            if (action.payload === 'checking') state.identity.crmDone = false;
        },
        setIdentityCrmDone(state, action) {
            state.identity.crmDone = Boolean(action.payload);
        },
        setIdentityResult(state, action) {
            const { check = null, note = '' } = action.payload || {};
            state.identity.check = check;
            state.identity.note = note;
            state.identity.status = 'done';
        },
        setIdentityResolution(state, action) {
            state.identity.resolution = action.payload || null;
        },
        requestIdentityFollowUp(state, action) {
            state.identity.followUpRequest = action.payload || null;
        },
        clearIdentityFollowUp(state) {
            state.identity.followUpRequest = null;
        },
        resetIdentity(state) {
            state.identity = initialIdentity;
        },
    },
});

export const {
    openCreateLeadDialog,
    closeCreateLeadDialog,
    setIdentityStatus,
    setIdentityCrmDone,
    setIdentityResult,
    setIdentityResolution,
    requestIdentityFollowUp,
    clearIdentityFollowUp,
    resetIdentity,
} = slice.actions;
export default slice.reducer;
